import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { columns } from "./columnsCheckBoxes";
import { usePiping } from "../../PipingContext";
import { getSizesOptions } from "../utils";
import {
  filterSpecRow,
  updateDerivedFields,
  getFamilyTableOptions,
} from "./utils";
import { MaterialReactTable } from "material-react-table";
import { postUnitWeightFromFamilyname } from "../../api";
import { getComponentTab } from "../utils";
import { BulkSelectDialog } from "./BulkSelectDialog";
import {
  mrtBodyCellSx,
  mrtHeadCellSx,
  mrtSurfaceProps,
} from "../../../../../../styles/mrtThemeProps";

const tabLabels = [
  "Pipes",
  "Flanges",
  "Fittings",
  "Valves",
  "Gaskets",
  "Instruments",
  "Special Items",
  "Hookup",
  "Fasteners",
];

const fittingsTabs = [
  "Adapters",
  "Bushings",
  "Caps",
  "Couplings",
  "Elbows",
  "Olets",
  "Plugs",
  "Reducers",
  "Tees",
  "Unions",
];
const FastenersTab = ["Bolts", "Nuts", "Washers"];

// ─── Shared match helpers ────────────────────────────────────────────────────

const rowMatches = (a, b) =>
  a.Size === b.Size &&
  a.Spec === b.Spec &&
  a.Components === b.Components &&
  a.Material === b.Material &&
  a.Ends === b.Ends &&
  a["Schedule/Rating"] === b["Schedule/Rating"] &&
  a["Additional Notes"] === b["Additional Notes"] &&
  a.TabName === b.TabName;

const rowKey = (r) =>
  `${r.Spec}|${r.Components}|${r.Size}|${r.Material}|${r.Ends}|${r["Schedule/Rating"]}|${r["Additional Notes"]}`;

// ────────────────────────────────────────────────────────────────────────────

async function addunitweighttospec(items) {
  const results = await Promise.all(
    items.map(async (item) => {
      const unitWeightVal = await postUnitWeightFromFamilyname(item);
      return { ...item, UnitWeight: unitWeightVal };
    }),
  );
  return results;
}

export function PartLibTableCheckBoxes({ revision }) {
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    key: 0,
  });

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbar((prev) => ({
      open: true,
      message,
      severity,
      key: prev.key + 1,
    }));
  }, []);

  const handleSnackbarClose = useCallback((event, reason) => {
    if (reason === "clickaway") return;

    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);
  const [openDialog, setOpenDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const [bulkSelectOpen, setBulkSelectOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);

  // ✅ Own the pagination state — MRT will never auto-reset it
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 50 });

  const prevSpecsRef = useRef(null);
  const rebuildCountRef = useRef(0);
  const skipCountRef = useRef(0);

  const isFittingsTab = tabLabels[tabIndex] === "Fittings";
  const isFastenersTab = tabLabels[tabIndex] === "Fasteners";
  const subTabs = isFittingsTab
    ? fittingsTabs
    : isFastenersTab
      ? FastenersTab
      : null;

  let activeTabName;
  if (isFittingsTab) {
    activeTabName = fittingsTabs[subTabIndex];
  } else if (isFastenersTab) {
    activeTabName = FastenersTab[subTabIndex];
  } else {
    activeTabName = tabLabels[tabIndex];
  }

  const {
    getSelectedSpecTable,
    selectedSpecs,
    allTables,
    fullSpecTable,
    partLibTable,
    setPartLibTable,
    setFastenersTable,
    allCombinationTable,
    setAllCombinationTable,
  } = usePiping();

  const currentTabData = useMemo(() => {
    return allCombinationTable.filter((row) => row.TabName === activeTabName);
  }, [allCombinationTable, activeTabName]);

  useEffect(() => {
    console.log("partLibTableeeeeeeeeeeeee", partLibTable);
    setFastenersTable({
      bolts: partLibTable[revision]?.["Bolts"] || [],
      nuts: partLibTable[revision]?.["Nuts"] || [],
      washers: partLibTable[revision]?.["Washers"] || [],
    });
  }, [partLibTable]);

  const allSpecData = useMemo(() => {
    if (
      !selectedSpecs ||
      !Array.isArray(selectedSpecs) ||
      selectedSpecs.length === 0
    )
      return [];
    if (!getSelectedSpecTable || typeof getSelectedSpecTable !== "function")
      return [];
    return selectedSpecs.flatMap(getSelectedSpecTable);
  }, [selectedSpecs, getSelectedSpecTable]);

  const specs = useMemo(() => {
    return [...new Set(allSpecData.map((item) => item.Spec))];
    console.log("specs", specs);
    console.log("allSpecData", allSpecData);
  }, [allSpecData]);

  // ─── Build allCombinationTable ─────────────────────────────────────────────
 useEffect(() => {
  let isCancelled = false;

  const rebuildAllCombinationTable = async () => {
    const currentSpecsKey = [...specs].sort().join(",");

    if (prevSpecsRef.current === currentSpecsKey) {
      skipCountRef.current++;
      if (skipCountRef.current % 10 === 0) {
        console.log(
          `⏭️ Skipped ${skipCountRef.current} rebuilds (${rebuildCountRef.current} actual rebuilds)`,
        );
      }
      return;
    }

    prevSpecsRef.current = currentSpecsKey;
    rebuildCountRef.current++;
    console.log(`🔨 Rebuild #${rebuildCountRef.current} triggered`);

    if (allSpecData.length === 0 || specs.length === 0) {
      console.log("⚠️ No spec data - setting empty table");
      setAllCombinationTable([]);
      return;
    }

    console.log(
      `📊 Building table for ${specs.length} specs, ${allSpecData.length} total items`,
    );

    const allTabsData = {};

    const allTabs = [
      "Pipes",
      "Flanges",
      "Adapters",
      "Bushings",
      "Caps",
      "Couplings",
      "Elbows",
      "Olets",
      "Plugs",
      "Reducers",
      "Tees",
      "Unions",
      "Valves",
      "Gaskets",
      "Instruments",
      "Special Items",
      "Hookup",
      "Bolts",
      "Nuts",
      "Washers",
    ];

    const tabCache = new Map();

    const getCachedComponentTab = async (component, spec) => {
      const cacheKey = `${spec}__${component}`;

      if (tabCache.has(cacheKey)) {
        return tabCache.get(cacheKey);
      }

      const tabName = await getComponentTab(component, spec);
      tabCache.set(cacheKey, tabName);
      return tabName;
    };

    for (const tabName of allTabs) {
      const newTable = [];

      for (const spec of specs) {
        const compsSet = new Set();

        for (const item of allSpecData) {
          const itemTabName = await getCachedComponentTab(
            item.Components,
            item.Spec,
          );

          if (item.Spec === spec && itemTabName === tabName) {
            compsSet.add(item.Components);
          }
        }

        const comps = [...compsSet];

        for (const comp of comps) {
          const baseRows = [];

          for (const item of allSpecData) {
            const itemTabName = await getCachedComponentTab(
              item.Components,
              item.Spec,
            );

            if (
              item.Spec === spec &&
              item.Components === comp &&
              itemTabName === tabName
            ) {
              baseRows.push(item);
            }
          }
          let sizes = [];

          try {
            sizes = await getSizesOptions(allSpecData, spec, comp);
          } catch (error) {
            sizes = [];
          }

          if (baseRows.length === 0 || sizes.length === 0) continue;

          for (const baseRow of baseRows) {
            const filteredSizes = sizes.filter((s) => s.range === baseRow.Size);

            for (const size of filteredSizes) {
              const categoryType =
                tabName === "Valves"
                  ? "Valve"
                  : tabName === "Instruments"
                    ? "Instrument"
                    : "Bulk";

              const newRow = {
                ...filterSpecRow(baseRow),
                select: false,
                Size: size.value,
                OriginalSizeRange: baseRow.Size,
                TabName: tabName,
                CategoryType: categoryType,
              };

              await updateDerivedFields(
                allSpecData,
                (row, key, value) => (row[key] = value),
                newRow,
                { ...newRow },
              );

             const familyOptions = await getFamilyTableOptions(
  newRow.Components,
  newRow.Spec,
  {
    "Schedule/Rating": newRow["Schedule/Rating"],
    Ends: newRow["Ends"],
    Material: newRow["Material"],
    "Additional Notes": newRow["Additional Notes"],
  },
  fullSpecTable,
);

              const uniqueNames = Array.from(
                new Set(
                  (familyOptions || [])
                    .map((cur) => String(cur?.Family_Name ?? "").trim())
                    .filter((n) => n && n !== "-"),
                ),
              );

              if (uniqueNames.length === 1 && !newRow["Family Table"]) {
                const onlyName = uniqueNames[0];

                newRow["Family Table"] = onlyName;

                const tableTarget =
                  familyOptions.find((cur) => cur.Family_Name === onlyName)
                    ?.Family_Table || "";

                if (tableTarget) {
                  newRow.FamilyTableTarget = tableTarget;
                }
              }

              newTable.push(newRow);
            }
          }
        }
      }

      allTabsData[tabName] = newTable;
    }
console.log("allTabsData", allTabsData);

    // if (isCancelled) return;
    const allRows = Object.values(allTabsData).flat();

    setAllCombinationTable((prevAllCombo) => {
      const result = allRows.map((newRow) => {
        const existingRow = prevAllCombo.find((prev) =>
          rowMatches(prev, newRow),
        );

        if (existingRow && existingRow.select) {
          return {
            ...newRow,
            ...existingRow,
            "Family Table":
              existingRow["Family Table"] ?? newRow["Family Table"],
            "Family Table Options":
              existingRow["Family Table Options"] ??
              newRow["Family Table Options"],
          };
        }

        const tabPartLib = partLibTable?.[revision]?.[newRow.TabName];

        if (tabPartLib) {
          const savedRow = tabPartLib.find(
            (org) =>
              org.Size === newRow.Size &&
              org.Spec === newRow.Spec &&
              org.Components === newRow.Components &&
              org.Material === newRow.Material &&
              org.Ends === newRow.Ends &&
              org["Schedule/Rating"] === newRow["Schedule/Rating"],
          );

          if (savedRow) {
            return {
              ...newRow,
              ...savedRow,
              select: true,
              TabName: newRow.TabName,
              "Family Table":
                savedRow["Family Table"] || newRow["Family Table"],
            };
          }
        }

        return newRow;
      });

      console.log(
        `Rebuilt allCombinationTable with ${result.length} total rows`,
      );
      console.log(`Selected rows: ${result.filter((r) => r.select).length}`);

      return result;
    });
  };

  rebuildAllCombinationTable().catch((error) => {
    console.error("❌ Failed to rebuild allCombinationTable:", error);
  });

  return () => {
    isCancelled = true;
  };
}, [specs, allSpecData, allTables, revision, fullSpecTable]);

  // ─── Sync allCombinationTable → partLibTable ───────────────────────────────
  useEffect(() => {
    console.log("🔄 Sync effect triggered");

    const selectedByTab = {};

    allCombinationTable.forEach((row) => {
      if (row.select && row.TabName) {
        if (!selectedByTab[row.TabName]) {
          selectedByTab[row.TabName] = [];
        }
        const { select, TabName, ...rest } = row;
        selectedByTab[row.TabName].push(rest);
      }
    });

    setPartLibTable((prev) => {
      const updatedRevision = { ...(prev[revision] || {}) };
      let hasChanges = false;

      Object.keys(selectedByTab).forEach((tabName) => {
        const prevTab = updatedRevision[tabName] || [];
        const newTab = selectedByTab[tabName];

        if (prevTab.length !== newTab.length) {
          hasChanges = true;
          updatedRevision[tabName] = newTab;
        } else {
          const prevKeys = new Set(prevTab.map(rowKey));
          const newKeys = new Set(newTab.map(rowKey));

          if (
            prevKeys.size !== newKeys.size ||
            [...prevKeys].some((k) => !newKeys.has(k))
          ) {
            hasChanges = true;
            updatedRevision[tabName] = newTab;
          }
        }
      });

      Object.keys(updatedRevision).forEach((tabName) => {
        if (!selectedByTab[tabName] && updatedRevision[tabName]?.length > 0) {
          updatedRevision[tabName] = [];
          hasChanges = true;
        }
      });

      if (!hasChanges) {
        console.log(
          "✅ No changes detected in sync - returning same reference",
        );
        return prev;
      }

      console.log("⚠️ Changes detected in sync - updating partLibTable");
      return {
        ...prev,
        [revision]: updatedRevision,
      };
    });
  }, [allCombinationTable, revision, setPartLibTable]);

  // ─── Handlers ─────────────────────────────────────────────────────────────

  const handleUpdate = async () => {
    setPendingAction("update");
    setOpenDialog(true);
  };

  const handleUpdateAssembly = async () => {
    setPendingAction("updateAssembly");
    setOpenDialog(true);
  };

  // const executeUpdate = async (scope) => {
  //   setOpenDialog(false);

  //   setSnackbarMessage("Update Family in Progress...");
  //   setSnackbarSeverity("info");
  //   setOpenSnackbar(true);

  //   let updatedData_ =
  //     scope === "current"
  //       ? currentTabData.filter((row) => row.select)
  //       : allCombinationTable.filter((row) => row.select);

  //   if (updatedData_.length === 0) {
  //     setSnackbarMessage("No items selected to update");
  //     setSnackbarSeverity("warning");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let updatedData = [];
  //   try {
  //     updatedData = await addunitweighttospec(updatedData_);
  //     console.log("Updated Data:", updatedData);
  //   } catch (error) {
  //     setSnackbarMessage("error in reading the data from the database");
  //     setSnackbarSeverity("error");
  //     setOpenSnackbar(true);
  //     console.error("Error in updating spec Pipe:", error);
  //   }

  //   try {
  //     const resp =
  //       await window.electron.piping.PipeSpecupdateDatabase(updatedData);
  //     console.log("response:", resp);
  //     setSnackbarMessage(
  //       `Updated ${resp.updated} row(s) in DB (${scope === "current" ? `Current Tab: ${activeTabName}` : "All Tabs"} - ${updatedData.length} items)`,
  //     );
  //     setSnackbarSeverity(resp.errors.length === 0 ? "success" : "error");
  //     setOpenSnackbar(true);
  //   } catch {
  //     setSnackbarMessage("error in updating the family table");
  //     setSnackbarSeverity("error");
  //     setOpenSnackbar(true);
  //   }

  //   try {
  //     const resp =
  //       await window.electron.piping.PipeSpecupdateFamily(updatedData);
  //     console.log("response:", resp);
  //     setSnackbarMessage(
  //       `${resp.message} (${scope === "current" ? `Current Tab: ${activeTabName}` : "All Tabs"} - ${updatedData.length} items)`,
  //     );
  //     setSnackbarSeverity(resp.ok ? "success" : "error");
  //     setOpenSnackbar(true);
  //   } catch {
  //     setSnackbarMessage("error in updating the family table");
  //     setSnackbarSeverity("error");
  //     setOpenSnackbar(true);
  //   }
  // };

  const executeUpdate = async (scope) => {
    setOpenDialog(false);

    const scopeLabel =
      scope === "current" ? `Current Tab: ${activeTabName}` : "All Tabs";

    const selectedRows =
      scope === "current"
        ? currentTabData.filter((row) => row.select)
        : allCombinationTable.filter((row) => row.select);

    if (selectedRows.length === 0) {
      showSnackbar("No items selected to update", "warning");
      return;
    }

    showSnackbar(
      `Update Family in Progress... (${scopeLabel} - ${selectedRows.length} items)`,
      "info",
    );

    let updatedData = [];

    try {
      updatedData = await addunitweighttospec(selectedRows);
      console.log("Updated Data:", updatedData);
    } catch (error) {
      console.error("Error reading unit weight from database:", error);
      showSnackbar("Error reading unit weight from database", "error");
      return;
    }

    let dbResp;

    try {
      dbResp = await window.electron.piping.PipeSpecupdateDatabase(updatedData);
      console.log("Database update response:", dbResp);
    } catch (error) {
      console.error("Error updating spec database:", error);
      showSnackbar("Error updating spec database", "error");
      return;
    }

    const dbErrors = Array.isArray(dbResp?.errors) ? dbResp.errors : [];

    if (dbErrors.length > 0) {
      showSnackbar(
        `Database update completed with ${dbErrors.length} error(s) (${scopeLabel} - ${updatedData.length} items)`,
        "error",
      );
      return;
    }

    try {
      const familyResp =
        await window.electron.piping.PipeSpecupdateFamily(updatedData);

      console.log("Family update response:", familyResp);

      const dbUpdated = Number(dbResp?.updated ?? 0);
      const familyMessage = familyResp?.message || "Family table updated";

      showSnackbar(
        `${familyMessage}. DB updated ${dbUpdated} row(s) (${scopeLabel} - ${updatedData.length} items)`,
        familyResp?.ok ? "success" : "error",
      );
    } catch (error) {
      console.error("Error updating family table:", error);
      showSnackbar("Error updating family table", "error");
    }
  };
  const executeUpdateAssembly = async (scope) => {
    setOpenDialog(false);

    const scopeLabel =
      scope === "current" ? `Current Tab: ${activeTabName}` : "All Tabs";

    const selectedRows =
      scope === "current"
        ? currentTabData.filter((row) => row.select)
        : allCombinationTable.filter((row) => row.select);

    if (selectedRows.length === 0) {
      showSnackbar("No items selected to update", "warning");
      return;
    }

    showSnackbar(
      `Update Assembly in Progress... (${scopeLabel} - ${selectedRows.length} items)`,
      "info",
    );

    let updatedData = [];

    try {
      updatedData = await addunitweighttospec(selectedRows);
      console.log("Updated Data:", updatedData);
    } catch (error) {
      console.error("Error reading unit weight from database:", error);
      showSnackbar("Error reading unit weight from database", "error");
      return;
    }

    try {
      const res = await window.electron.piping.PipeSpecupdatePart(updatedData);

      console.log("Assembly update response:", res);

      showSnackbar(
        `${res?.message || "Assembly update completed"} (${scopeLabel} - ${updatedData.length} items)`,
        res?.ok ? "success" : "error",
      );
    } catch (error) {
      console.error("Error updating pipe spec part:", error);
      showSnackbar("Error updating pipe spec part", "error");
    }
  };
  // const executeUpdateAssembly = async (scope) => {
  //   setOpenDialog(false);

  //   setSnackbarMessage("Update Assembly in Progress...");
  //   setSnackbarSeverity("info");
  //   setOpenSnackbar(true);

  //   let updatedData_ =
  //     scope === "current"
  //       ? currentTabData.filter((row) => row.select)
  //       : allCombinationTable.filter((row) => row.select);

  //   if (updatedData_.length === 0) {
  //     setSnackbarMessage("No items selected to update");
  //     setSnackbarSeverity("warning");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   let updatedData = [];
  //   try {
  //     updatedData = await addunitweighttospec(updatedData_);
  //     console.log("Updated Data:", updatedData);
  //   } catch (error) {
  //     setSnackbarMessage("error in reading the data from the database");
  //     setSnackbarSeverity("error");
  //     setOpenSnackbar(true);
  //     console.error("Error in updating spec Pipe:", error);
  //   }

  //   try {
  //     const res = await window.electron.piping.PipeSpecupdatePart(updatedData);
  //     console.log("response:", res);
  //     setSnackbarMessage(
  //       `${res.message} (${scope === "current" ? `Current Tab: ${activeTabName}` : "All Tabs"} - ${updatedData.length} items)`,
  //     );
  //     setSnackbarSeverity(res.ok ? "success" : "error");
  //     setOpenSnackbar(true);
  //   } catch (error) {
  //     console.error("Error in updating pipe spec part:", error);
  //     setSnackbarMessage("Error in updating pipe spec part");
  //     setSnackbarSeverity("error");
  //     setOpenSnackbar(true);
  //   }
  // };

  const handleDialogChoice = (scope) => {
    if (pendingAction === "update") {
      executeUpdate(scope);
    } else if (pendingAction === "updateAssembly") {
      executeUpdateAssembly(scope);
    }
  };

  // ✅ Stable handlers with useCallback
  const handleDeleteRow = useCallback(
    (rowIndex) => {
      const rowToDelete = currentTabData[rowIndex];
      if (!rowToDelete) return;
      const tabName = rowToDelete.TabName || activeTabName;

      setAllCombinationTable((prev) =>
        prev.filter(
          (cur) => !rowMatches(cur, { ...rowToDelete, TabName: tabName }),
        ),
      );

      setPartLibTable((prev) => {
        const updatedRevision = { ...(prev[revision] || {}) };
        const updatedTab = (updatedRevision[tabName] || []).filter(
          (cur) =>
            !(
              cur.Size === rowToDelete.Size &&
              cur.Spec === rowToDelete.Spec &&
              cur.Components === rowToDelete.Components &&
              cur.Material === rowToDelete.Material &&
              cur.Ends === rowToDelete.Ends &&
              cur["Schedule/Rating"] === rowToDelete["Schedule/Rating"]
            ),
        );
        return {
          ...prev,
          [revision]: { ...updatedRevision, [tabName]: updatedTab },
        };
      });
    },
    [
      currentTabData,
      activeTabName,
      revision,
      setAllCombinationTable,
      setPartLibTable,
    ],
  );

  const handleFieldUpdate = useCallback(
    (row, key, value) => {
      const originalRow = row.original;

      setAllCombinationTable((prev) =>
        prev.map((cur) =>
          rowMatches(cur, originalRow) ? { ...cur, [key]: value } : cur,
        ),
      );

      if (originalRow.select) {
        setPartLibTable((prev) => {
          const updatedRevision = { ...(prev[revision] || {}) };
          const tabName = originalRow.TabName || activeTabName;
          const updatedTab = (updatedRevision[tabName] || []).filter(
            (cur) =>
              !(
                cur.Size === originalRow.Size &&
                cur.Spec === originalRow.Spec &&
                cur.Components === originalRow.Components &&
                cur.Material === originalRow.Material &&
                cur.Ends === originalRow.Ends &&
                cur["Schedule/Rating"] === originalRow["Schedule/Rating"] &&
                cur["Additional Notes"] === originalRow["Additional Notes"]
              ),
          );
          updatedTab.push({ ...originalRow, [key]: value });
          return {
            ...prev,
            [revision]: { ...updatedRevision, [tabName]: updatedTab },
          };
        });
      }
    },
    [activeTabName, revision, setAllCombinationTable, setPartLibTable],
  );

  const handleToggleRow = useCallback(
    (row, checked) => {
      console.log(
        `[allCombinationTable] ${checked ? "✅ selected" : "⬜ deselected"}`,
        row,
      );

      setAllCombinationTable((prev) =>
        prev.map((cur) =>
          rowMatches(cur, row) ? { ...cur, select: checked } : cur,
        ),
      );

      setPartLibTable((prev) => {
        const updatedRevision = { ...(prev[revision] || {}) };
        const tabName = row.TabName || activeTabName;
        const updatedTab = (updatedRevision[tabName] || []).filter(
          (cur) =>
            !(
              cur.Size === row.Size &&
              cur.Spec === row.Spec &&
              cur.Components === row.Components &&
              cur.Material === row.Material &&
              cur.Ends === row.Ends &&
              cur["Schedule/Rating"] === row["Schedule/Rating"] &&
              cur["Additional Notes"] === row["Additional Notes"]
            ),
        );
        if (checked) {
          const { select, TabName, ...toAdd } = row;
          updatedTab.push(toAdd);
        }
        return {
          ...prev,
          [revision]: { ...updatedRevision, [tabName]: updatedTab },
        };
      });
    },
    [activeTabName, revision, setAllCombinationTable, setPartLibTable],
  );

  // ✅ Memoized columns — only rebuilds when deps change
  const memoizedColumns = useMemo(
    () =>
      columns(
        allTables,
        handleFieldUpdate,
        handleDeleteRow,
        handleToggleRow,
        fullSpecTable,
      ),
    [
      allTables,
      handleFieldUpdate,
      handleDeleteRow,
      handleToggleRow,
      fullSpecTable,
    ],
  );

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <Box sx={{ bgcolor: "background.paper", border: 1, borderColor: "divider" }}>
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => {
          setTabIndex(newIndex);
          setSubTabIndex(0);
          setPagination((p) => ({ ...p, pageIndex: 0 }));
        }}
        sx={{
          bgcolor: "background.paper",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        {tabLabels.map((label) => (
          <Tab label={label} key={label} />
        ))}
      </Tabs>

      {subTabs && (
        <Tabs
          value={subTabIndex}
          onChange={(e, newIndex) => {
            setSubTabIndex(newIndex);
            // ✅ Reset to page 1 only when user switches sub-tabs
            setPagination((p) => ({ ...p, pageIndex: 0 }));
          }}
          sx={{ borderBottom: 1, borderColor: "divider", ml: 2 }}
        >
          {subTabs.map((label) => (
            <Tab label={label} key={label} />
          ))}
        </Tabs>
      )}

      <Box sx={{ p: 2, display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={handleUpdate}>
          Update
        </Button>
        <Button variant="contained" onClick={handleUpdateAssembly}>
          Update Assembly
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => setBulkSelectOpen(true)}
        >
          Bulk Select
        </Button>
        <Snackbar
          key={snackbar.key}
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        {/* <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbarMessage}
          </Alert>
        </Snackbar> */}
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="update-scope-dialog-title"
      >
        <DialogTitle id="update-scope-dialog-title">
          Select Update Scope
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you want to update{" "}
            {pendingAction === "update" ? "Family" : "Assembly"} for:
          </DialogContentText>
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
            <DialogContentText sx={{ fontWeight: "bold" }}>
              • Current Tab Only: {activeTabName} (
              {currentTabData.filter((r) => r.select).length} selected items)
            </DialogContentText>
            <DialogContentText sx={{ fontWeight: "bold" }}>
              • All Tabs: ({allCombinationTable.filter((r) => r.select).length}{" "}
              selected items)
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={() => handleDialogChoice("current")}
            variant="contained"
            color="primary"
          >
            Current Tab ({activeTabName})
          </Button>
          <Button
            onClick={() => handleDialogChoice("all")}
            variant="contained"
            color="secondary"
          >
            All Tabs
          </Button>
        </DialogActions>
      </Dialog>

      <MaterialReactTable
        columns={memoizedColumns}
        data={currentTabData}
        onRowSelectionChange={() => { }}
        enableTopToolbar={true}
        enableStickyHeader={true}
        enableSorting={false}
        manualPagination={false}
        onPaginationChange={setPagination}
        state={{ pagination }}
        autoResetPageIndex={false}
        {...mrtSurfaceProps}
        muiTableContainerProps={{ sx: { maxHeight: 600, backgroundColor: "background.paper" } }}
        muiTableBodyCellProps={{
          sx: {
            ...mrtBodyCellSx,
            borderRight: 1,
            fontSize: "0.65rem",
            padding: "0px 3px !important",
            verticalAlign: "center",
            overflow: "visible",
          },
        }}
        muiTableHeadCellProps={{
          sx: {
            ...mrtHeadCellSx,
            fontWeight: "bold",
            fontSize: "0.65rem",
            borderRight: 1,
            width: "36px",
            lineHeight: "10px",
          },
        }}
      />

      <BulkSelectDialog
        open={bulkSelectOpen}
        onClose={() => setBulkSelectOpen(false)}
        revision={revision}
        currentTabData={currentTabData}
        activeTabName={activeTabName}
      />
    </Box>
  );
}
